import React from 'react';

import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import FirstInInboxPng from './first-in-inbox.png';
import FirstInInboxPngMobile from './first-in-inbox_mobile.png';
import FirstInInboxWebp from './first-in-inbox.webp';
import FirstInInboxWebpMobile from './first-in-inbox_mobile.webp';
import Arrows from './arrows-pointing-inward.svg';
import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { FAQTab } from '../../../../common/display/faqTab/FAQTab';
import { useGetHasProduct } from '../../../../../customHooks/useGetHasProduct.hook';
import { ProductType } from '../../../../../@types/product';
import { useGetDiscoverKaeuferPlusLink } from '../../../../../customHooks/useGetDiscoverKaeuferPlusLink.hook';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = ({ hasKaeuferPlus }: { hasKaeuferPlus: boolean }) => {
  const { t } = useIntl();
  return (
    <div>
      <div className='font-heading-xsmall-regular' style={styles.overviewTab}>
        {t({
          id: 'benefits.firstInInbox.modal.overview',
          defaultMessage: 'Your messages sent to the offering person...',
        })}
      </div>
      {!hasKaeuferPlus && (
        <ul className='list-check list-spacing-s padding-top-l'>
          <li data-testid='kaeufer-plus-label-with-checkmark'>
            <Msg
              id='benefits.exclusiveListings.modal.overview.activeKaeuferPlus'
              defaultMessage='Keep Käufer Plus...'
              values={{
                BuyerPlusLogo: <PlusBadge variant='buy' />,
              }}
            />
          </li>
        </ul>
      )}
    </div>
  );
};

const ButtonArea = () => {
  const discoverKaeuferPlusLink = useGetDiscoverKaeuferPlusLink({ ctaType: 'firstInInbox' });
  return (
    <div className='align-center'>
      <a className='button-secondary button-rounded' href={discoverKaeuferPlusLink}>
        <Msg id='benefits.exclusiveListings.modal.linkButton' defaultMessage='Discover KäuferPlus' />
      </a>
    </div>
  );
};

export const FirstInInbox = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const hasKaeuferPlus = useGetHasProduct(ProductType.KaeuferPlus);

  return (
    <Modal
      title={t({ id: 'benefits.firstInInbox.headline', defaultMessage: 'First in inbox' })}
      isVisible={isVisible}
      image={FirstInInboxPng}
      imageWebp={FirstInInboxWebp}
      imageMobile={FirstInInboxPngMobile}
      imageMobileWebp={FirstInInboxWebpMobile}
      imageAlt={t({
        id: 'benefits.firstInInbox.modal.image',
        defaultMessage: 'Smartphone display showing vendors list',
      })}
      imageBackgroundStyles={{
        '@media (min-width: 669px)': {
          backgroundImage: `url(${Arrows})`,
          backgroundSize: 'auto 280px',
          backgroundPosition: 'center bottom, 55% center',
        },
      }}
      imageUseFullWidth={false}
      tabsContent={[
        <OverviewTab key='benefits.firstInInbox.modal.overview' hasKaeuferPlus={hasKaeuferPlus} />,
        <FAQTab key='benefits.firstInInbox.modal.faq' benefit='firstInInbox' />,
      ]}
      buttonArea={hasKaeuferPlus ? null : <ButtonArea />}
      benefit={Benefit.FIRST_IN_INBOX}
      onClose={onClose}
    />
  );
};
